import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=4cf3e395&scoped=true&"
import script from "./SecondStep.vue?vue&type=script&lang=ts&"
export * from "./SecondStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf3e395",
  null
  
)

export default component.exports